import React from 'react';
import PropTypes from 'prop-types';
import {Modal as OdsModal} from '@tkww/orion-web-ds-dialog';
import noop from '../../utils/noop';

const Modal = ({onClose = noop, ...rest}) => {
  return <OdsModal onClose={onClose} {...rest} />;
};

Modal.propTypes = {
  onClose: PropTypes.func,
};

export default Modal;
